import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EasyColumns, EasyTableEvent, sm} from '@shared/components/easy-table.component';
import {Price, PriceRule} from '@app/models/price-rule';
import {Config, DefaultConfig} from 'ngx-easy-table';
import {CourseService} from '@app/@core/services/course.service';
import {PriceRuleRepository} from '@app/@core/repositories/price-rule.repository';
import {comma} from '@shared/helper/helpers';

@Component({
    selector: 'app-price-rule-table',
    template: `
        <app-easy-table #table
                        [configuration]="configuration"
                        [columns]="columns"
                        [data]="items"
                        (rowClick)="onRowClick($event)"
                        [showFooter]="false"
        ></app-easy-table>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PriceRuleTableComponent implements OnInit {
    @Input()
    items: PriceRule[];

    @Output() rowClick = new EventEmitter<PriceRule>();

    configuration: Config = {
        ...DefaultConfig,
        paginationEnabled: false,
        rows: 30
    };

    columns: EasyColumns<PriceRule>[] = sm([
        {key: 'name', title: 'Name', cssClass: {includeHeader: false, name: 'text-primary text-sm'}},
        {key: 'dayString', title: 'Days'},
        {key: 'priceType', title: 'Type'},
        {key: 'specialPrice', title: 'Spe', type: 'boolean'},
        {key: '', title: 'Time', func: (v, row) => `${row.tstart}-${row.tend}`},
        {
            key: '', title: 'GolfDigg', func: (value, row) => {
                const sale = row.map['1']?.sale;
                const base = row.map['1']?.base;
                return `${sale?.toLocaleString()} / ${base?.toLocaleString()}`;
            },
            cssClass: {name: 'text-primary text-sm', includeHeader: false}
        },
        {
            key: '', title: 'TPC', func: (value, row) => {
                const sale = row.map['2']?.sale;
                const base = row.map['2']?.base;
                return sale ? `${sale?.toLocaleString()} / ${base?.toLocaleString()}` : '-';
            },
            cssClass: {name: 'text-orange-500 text-sm', includeHeader: false}
        },
        {
            key: '', title: 'HD', func: (value, row) => {
                return row.enableHotDeal ? row.hotDealPrices['3']?.price?.toLocaleString() : '-';
            },
            cssClass: {name: 'text-red-500 text-sm', includeHeader: false}
        },
        {
            key: '', title: 'Cart/Caddy', func: (value, row) => {
                const cart = row.cartSetting;
                return cart?.active ? '*Custom*' : 'Default';
            }
        },
        {key: 'season.start', title: 'From', type: 'date'},
        {key: 'season.end', title: 'To', type: 'date'},
        // {key: 'isActive', title: 'Act', type: 'boolean'},
        {
            key: '', title: 'Note', func: (v, row) => {
                if (row.freeCart || row.freeCaddy){
                    return `Free ${row.freeCart ? 'CT' : '-'}/${row.freeCaddy ? 'CD' : '-'}`;
                }
                return '';
            }
        },
        // {key: 'party', title: 'Party', type: 'boolean'},
        // {key: '', title: 'Golfer', func: (v, row) => `${row.minperson}-${row.maxperson}`},
    ]);

    rows: { source: Price }[];

    selectedCourse: string;

    constructor(
        public courseService: CourseService,
        public priceRuleService: PriceRuleRepository,
    ) {
    }

    ngOnInit(): void {
    }

    onRowClick($event: EasyTableEvent<PriceRule>) {
        this.rowClick.emit($event.value.row.source);
    }
}
